import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SchedaCoopAltreCoopFormService } from './scheda-coop-altre-coop-form.service';

@NgModule({
    declarations: [],
    imports: [CommonModule, ReactiveFormsModule],
    providers: [SchedaCoopAltreCoopFormService],
})
export class SchedaCoopAltreCoopFormModule {}